import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import BrandAnimation from "../components/BrandAnimation";
import Services from "../components/Services";
import AIFeatures from "../components/AIFeatures";
import TechShowcase from "../components/TechShowcase";
import CTA from "../components/CTA";
import Footer from "../components/Footer";

const BusinessHomepage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <Navbar />
      <Hero />
      <BrandAnimation />
      <Services />
      <AIFeatures />
      <TechShowcase />
      <CTA />
      <Footer />
    </div>
  );
};

export default BusinessHomepage;
